/* eslint-disable comma-dangle, no-var, react/jsx-closing-bracket-location, react/prop-types, react/sort-comp, space-before-function-paren */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var ReactDOM = require("react-dom");
var _ = require("underscore");

var MathOutput = require("../components/math-output.jsx");
var SimpleKeypadInput = require("../components/simple-keypad-input.jsx");
var Renderer = require("../renderer.jsx");
var Util = require("../util.js");

var keypadElementPropType = require("../../math-input").propTypes.keypadElementPropType;

var ApiOptions = require("../perseus-api.jsx").Options;
var KhanAnswerTypes = require("../util/answer-types.js");

var _require = require("../gorgon/proptypes.js"),
    linterContextProps = _require.linterContextProps,
    linterContextDefault = _require.linterContextDefault;

var assert = require("../interactive2/interactive-util.js").assert;

/* Input handling: Maps a (row, column) pair to a unique ref used by React,
 * and extracts (row, column) pairs from input paths, used to allow outsiders
 * to focus, blur, set input values, etc. */
var getInputPath = function getInputPath(row, column) {
    return ["" + row, "" + column];
};

var getDefaultPath = function getDefaultPath() {
    return getInputPath(0, 0);
};

var getRowFromPath = function getRowFromPath(path) {
    // 'path' should be a (row, column) pair
    assert(_.isArray(path) && path.length === 2);
    return +path[0];
};

var getColumnFromPath = function getColumnFromPath(path) {
    // 'path' should be a (row, column) pair
    assert(_.isArray(path) && path.length === 2);
    return +path[1];
};

var getRefForPath = function getRefForPath(path) {
    var row = getRowFromPath(path);
    var column = getColumnFromPath(path);
    return "answer" + row + "," + column;
};

var Table = React.createClass({
    displayName: "Table",

    propTypes: {
        answers: React.PropTypes.arrayOf(React.PropTypes.arrayOf(React.PropTypes.string)),
        editableHeaders: React.PropTypes.bool,
        // The editor to use when editableHeaders is enabled
        Editor: React.PropTypes.func,
        headers: React.PropTypes.arrayOf(React.PropTypes.string),
        keypadElement: keypadElementPropType,
        trackInteraction: React.PropTypes.func.isRequired,
        linterContext: linterContextProps
    },

    getDefaultProps: function getDefaultProps() {
        var defaultRows = 4;
        var defaultColumns = 1;
        var blankAnswers = _(defaultRows).times(function () {
            return Util.stringArrayOfSize(defaultColumns);
        });
        return {
            apiOptions: ApiOptions.defaults,
            headers: [""],
            editableHeaders: false,
            rows: defaultRows,
            columns: defaultColumns,
            answers: blankAnswers,
            linterContext: linterContextDefault
        };
    },

    _getRows: function _getRows() {
        return this.props.answers.length;
    },

    _getColumns: function _getColumns() {
        return this.props.answers[0].length;
    },

    render: function render() {
        var _this = this;

        var rows = this._getRows();
        var columns = this._getColumns();
        var headers = this.props.headers;

        var InputComponent = void 0;
        var inputStyle = void 0;
        if (this.props.apiOptions.customKeypad) {
            InputComponent = SimpleKeypadInput;
            // NOTE(charlie): This is intended to match the "width: 80px" in
            // input in table.less. Those values should be kept in-sync.
            inputStyle = { width: 80 };
        } else if (this.props.apiOptions.staticRender) {
            InputComponent = MathOutput;
            inputStyle = {};
        } else {
            InputComponent = "input";
            inputStyle = {};
        }

        return React.createElement(
            "table",
            { className: "perseus-widget-table-of-values non-markdown" },
            React.createElement(
                "thead",
                null,
                React.createElement(
                    "tr",
                    null,
                    _.map(headers, function (header, i) {
                        if (_this.props.editableHeaders) {
                            return React.createElement(
                                "th",
                                { key: i },
                                React.createElement(_this.props.Editor, {
                                    ref: "columnHeader" + i,
                                    apiOptions: _this.props.apiOptions,
                                    content: header,
                                    widgetEnabled: false,
                                    onChange: _.partial(_this.onHeaderChange, i)
                                })
                            );
                        } else {
                            return React.createElement(
                                "th",
                                { key: i },
                                React.createElement(Renderer, {
                                    content: header,
                                    linterContext: _this.props.linterContext
                                })
                            );
                        }
                    })
                )
            ),
            React.createElement(
                "tbody",
                null,
                _(rows).times(function (r) {
                    return React.createElement(
                        "tr",
                        { key: r },
                        _(columns).times(function (c) {
                            return React.createElement(
                                "td",
                                { key: c },
                                React.createElement(InputComponent, {
                                    ref: getRefForPath(getInputPath(r, c)),
                                    type: "text",
                                    value: _this.props.answers[r][c],
                                    keypadElement: _this.props.keypadElement,
                                    disabled: _this.props.apiOptions.readOnly,
                                    onFocus: _.partial(_this._handleFocus, getInputPath(r, c)),
                                    onBlur: _.partial(_this._handleBlur, getInputPath(r, c)),
                                    onChange: _.partial(_this.onValueChange, r, c),
                                    style: inputStyle
                                })
                            );
                        })
                    );
                })
            )
        );
    },

    getUserInput: function getUserInput() {
        return _.map(this.props.answers, _.clone);
    },

    onValueChange: function onValueChange(row, column, eventOrValue) {
        var answers = _.map(this.props.answers, _.clone);

        // If this is coming from an "input", the last argument will be an
        // event. If it's coming from a SimpleKeypadInput, it'll be the value.
        answers[row][column] = eventOrValue.target ? eventOrValue.target.value : eventOrValue;

        this.props.onChange({
            answers: answers
        });
        this.props.trackInteraction();
    },

    onHeaderChange: function onHeaderChange(index, e) {
        var headers = this.props.headers.slice();
        headers[index] = e.content;
        this.props.onChange({
            headers: headers
        });
    },

    simpleValidate: function simpleValidate(rubric) {
        return Table.validate(this.getUserInput(), rubric);
    },

    _handleFocus: function _handleFocus(inputPath) {
        this.props.onFocus(inputPath);
    },

    _handleBlur: function _handleBlur(inputPath) {
        this.props.onBlur(inputPath);
    },

    focus: function focus() {
        this.focusInputPath(getDefaultPath());
        return true;
    },

    focusInputPath: function focusInputPath(path) {
        var inputID = getRefForPath(path);
        var inputComponent = this.refs[inputID];
        if (this.props.apiOptions.customKeypad) {
            inputComponent.focus();
        } else if (this.props.apiOptions.staticRender) {
            inputComponent.focus();
        } else {
            ReactDOM.findDOMNode(inputComponent).focus();
        }
    },

    blurInputPath: function blurInputPath(path) {
        var inputID = getRefForPath(path);
        var inputComponent = this.refs[inputID];
        if (this.props.apiOptions.customKeypad) {
            inputComponent.blur();
        } else if (this.props.apiOptions.staticRender) {
            inputComponent.blur();
        } else {
            ReactDOM.findDOMNode(inputComponent).blur();
        }
    },

    getDOMNodeForPath: function getDOMNodeForPath(path) {
        var inputID = getRefForPath(path);
        return ReactDOM.findDOMNode(this.refs[inputID]);
    },

    getInputPaths: function getInputPaths() {
        var rows = this._getRows();
        var columns = this._getColumns();
        var inputPaths = [];
        _(rows).times(function (r) {
            _(columns).times(function (c) {
                var inputPath = getInputPath(r, c);
                inputPaths.push(inputPath);
            });
        });
        return inputPaths;
    },

    getGrammarTypeForPath: function getGrammarTypeForPath(inputPath) {
        return "number";
    },

    setInputValue: function setInputValue(path, newValue, cb) {
        // Extract row, column information
        var row = getRowFromPath(path);
        var column = getColumnFromPath(path);

        var answers = _.map(this.props.answers, _.clone);
        answers[row][column] = newValue;
        this.props.onChange({
            answers: answers
        }, cb);
    }
});

_.extend(Table, {
    validate: function validate(state, rubric) {
        var filterNonEmpty = function filterNonEmpty(table) {
            return _.filter(table, function (row) {
                // Check if row has a cell that is nonempty
                return _.some(row, _.identity);
            });
        };
        var solution = filterNonEmpty(rubric.answers);
        var supplied = filterNonEmpty(state);
        var hasEmptyCell = _.some(supplied, function (row) {
            return _.some(row, function (cell) {
                return cell === "";
            });
        });
        if (hasEmptyCell || !supplied.length) {
            return {
                type: "invalid",
                message: null
            };
        }
        if (supplied.length !== solution.length) {
            return {
                type: "points",
                earned: 0,
                total: 1,
                message: null
            };
        }
        var createValidator = KhanAnswerTypes.number.createValidatorFunctional;
        var message = null;
        var allCorrect = _.every(solution, function (rowSolution) {
            var i;
            for (i = 0; i < supplied.length; i++) {
                var rowSupplied = supplied[i];
                var correct = _.every(rowSupplied, function (cellSupplied, i) {
                    var cellSolution = rowSolution[i];
                    var validator = createValidator(cellSolution, {
                        simplify: true
                    });
                    var result = validator(cellSupplied);
                    if (result.message) {
                        message = result.message;
                    }
                    return result.correct;
                });
                if (correct) {
                    supplied.splice(i, 1);
                    return true;
                }
            }
            return false;
        });
        return {
            type: "points",
            earned: allCorrect ? 1 : 0,
            total: 1,
            message: message
        };
    }
});

var propTransform = function propTransform(editorProps) {
    // Remove answers before passing to widget
    var rows = editorProps.answers.length;
    var columns = editorProps.answers[0].length;
    var blankAnswers = _(rows).times(function () {
        return Util.stringArrayOfSize(columns);
    });
    return _.extend({}, editorProps, {
        answers: blankAnswers
    });
};

module.exports = {
    name: "table",
    displayName: "Table of values",
    accessible: true,
    widget: Table,
    transform: propTransform,
    hidden: true,
    isLintable: true
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/table.jsx
 ** module id = 150
 ** module chunks = 0 1
 **/